import { CountryCode } from '@/Enums';
import { RootState } from '@/Redux/RootReducer';
import { createSelector } from '@reduxjs/toolkit';
import { countryZoneUtils } from './utils';

const applicationAccessCountryZoneStateSelector = (state: RootState) => state.warehouseLogisticsPage.applicationAccess;
const countryZones = createSelector(applicationAccessCountryZoneStateSelector, (state) => state.countryZones || []);
const countryZoneById = (countryZoneId: string | number) =>
  createSelector(applicationAccessCountryZoneStateSelector, (state) => {
    return countryZoneUtils.countryZoneById(countryZoneId, state.countryZones);
  });

const selectedCountryCode = createSelector(
  applicationAccessCountryZoneStateSelector,
  (state) => state.selectedCountryCode,
);
const selectedCountryZone = createSelector(applicationAccessCountryZoneStateSelector, (state) =>
  state.countryZones.find((x) => x.country === state.selectedCountryCode),
);

const modalWindowType = createSelector(applicationAccessCountryZoneStateSelector, (state) => state.modalWindowType);
const connectionStatus = createSelector(applicationAccessCountryZoneStateSelector, (state) => state.connectionStatus);
const logisticTypeOptions = createSelector(
  applicationAccessCountryZoneStateSelector,
  (state) => state.logisticTypeOptions,
);

const availableLogisticTypeOptions = (country: CountryCode) =>
  createSelector(applicationAccessCountryZoneStateSelector, (state) => {
    const countryZone = state.countryZones.find((x) => x.country === country);
    if (countryZone) {
      return state.logisticTypeOptions.filter((x) => countryZone.logistics.every((y) => y.logisticId != x.key));
    }

    return state.logisticTypeOptions;
  });

export const applicationAccessCountryZoneSelectors = {
  countryZones,
  countryZoneById,
  modalWindowType,
  logisticTypeOptions,
  availableLogisticTypeOptions,
  selectedCountryCode,
  selectedCountryZone,
  connectionStatus,
};
